<template>
  <div class="fileHouse" v-show="childFalse">
    <div class="topBox">
      <el-button @click="childback" type="">返回</el-button>
    </div>
    <div class="bottomBox">
      <el-card class="tree-card" :body-style="treeCard">
        <div class="basic">
          <div class="basicTitle">基本信息</div>
          <div class="basicImgbox">
            <div class="basicName">
              <div class="basicItem">
                <span>房屋类别:</span>
                <span>{{ peopleList.houseTypeDict }}</span>
              </div>
              <div class="basicItem">
                <span>房屋性质:</span>
                <span>{{ peopleList.housePropertyDict }}</span>
              </div>
              <div class="basicItem">
                <span>房屋用途:</span>
                <span>{{ peopleList.houseUsage }}</span>
              </div>
              <div class="basicItem">
                <span>居住现状:</span>
                <span>{{ peopleList.houseLiveDict }}</span>
              </div>
            </div>
          </div>
          <div class="basicItem">
            <span>房屋间数:</span>
            <span>{{ peopleList.houseNumber }}</span>
          </div>
          <div class="basicItem">
            <span>房屋面积:</span>
            <span>{{ peopleList.houseSpace }}</span>
          </div>
          <div class="basicItem">
            <span>房屋地址:</span>
            <span>{{ peopleList.houseAddress }}</span>
          </div>
          <div class="basicItem">
            <span>产权编号:</span>
            <span>{{ peopleList.houseCode }}</span>
          </div>
          <div class="basicTitle">托管人信息</div>
          <div class="basicItem">
            <span>姓名:</span>
            <span>{{ peopleList.trusteeName }}</span>
          </div>
          <div class="basicItem">
            <span>证件号码:</span>
            <span>{{ peopleList.trusteeCardNumber }}</span>
          </div>
          <div class="basicItem">
            <span>联系电话:</span>
            <span>{{ peopleList.trusteeTelphone }}</span>
          </div>
          <div class="basicItem">
            <span>与房主关系:</span>
            <span>{{ peopleList.trusteeOrOwner }}</span>
          </div>
          <div class="basicTitle">房主信息</div>
          <div class="basicItem">
            <span>姓名:</span>
            <span>{{ peopleList.ownerName }}</span>
          </div>
          <div class="basicItem">
            <span>证件号码:</span>
            <span>{{ peopleList.ownerCardNumber }}</span>
          </div>
          <div class="basicItem">
            <span>联系电话:</span>
            <span>{{ peopleList.ownerTelphone }}</span>
          </div>
          <div class="basicTitle">其他信息</div>
          <div class="basicItem">
            <span>备注:</span>
            <span>{{ peopleList.comment }}</span>
          </div>
          <div class="basicItem">
            <span>登记人姓名:</span>
            <span>{{ peopleList.userId }}</span>
          </div>
          <div class="basicItem">
            <span>登记单位:</span>
            <span>{{ peopleList.unitName }}</span>
          </div>
          <div class="basicItem">
            <span>登记时间:</span>
            <span>{{ peopleList.updateTime }}</span>
          </div>
          <div class="basicTitle">房屋所属单位</div>
          <div class="basicItem">
            <span>单位编码:</span>
            <span>{{ peopleList.unitCode }}</span>
          </div>
          <div class="basicItem">
            <span>单位名称:</span>
            <span>{{ peopleList.unitName }}</span>
          </div>
          <!--  -->
        </div>
      </el-card>
      <div class="rightcenter">
        <commentright
          :dialogCount="peopleList"
          :showType="showType"
        ></commentright>
      </div>

      <!-- <div class="center-card" :body-style="treeCard">
        <div class="centerbg">
          <div class="imgone">
            <img  src="@/assets/images/threeSolid/threecor.png" />
          </div>
          <div class="imgtwo">
            <img  src="@/assets/images/threeSolid/threecor.png" />
          </div>
          <div class="imgthree">
            <img  src="@/assets/images/ceicon.png" />
          </div>
          <div class="centerbtn">
            <div class="btnitem"
            @click="clickCenter(item)"
            v-for="item in peopleList.furtherList" :key="item.type">
              {{item.name}}
            </div>
          </div>
        </div>
      </div> -->
      <!-- <el-card class="tree-card" :body-style="treeCard">
        <div class="basic">
          <div v-if="modelShow==='prisonInfoList'">
            <div class="basicTitle">人员信息</div>
            <template v-if="peopleList.prisonInfoList&&peopleList.prisonInfoList.length===1">
              <template v-for="item in peopleright" :key="item.prop">
                <div class="basicItem">
                  <span>{{item.name}}:</span>
                  <span v-for="l in peopleList.prisonInfoList"
                  :key="l.unitId">
                  {{l[item.prop]}}
                  </span>
                </div>
              </template>
            </template>
          </div>
          <ul class='search-results' v-if="modelShow==='prisonInfoList'">
            <template v-if="peopleList.prisonInfoList&&peopleList.prisonInfoList.length>1">
            <template  v-for="l in peopleList.prisonInfoList"
                  :key="l.regionId" >
              <li class='results-item'>
                <div class='item-details'>
                  <div class='details-info'>
                    <span class='label'>国籍</span>
                    <span class='value'>{{l.nationalityDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>姓名</span>
                    <span class='value'>{{l.name}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>性别</span>
                    <span class='value'>{{l.sexDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>民族</span>
                    <span class='value'>{{l.nationDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>证件号码</span>
                    <span class='value'>{{l.cardNumber}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>出生日期</span>
                    <span class='value'>{{l.birthday}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>婚姻状况</span>
                    <span class='value'>{{l.maritalDict}}</span>
                  </div>
                </div>
              </li>
              </template>
            </template>
          </ul>
          <div v-if="modelShow==='unitInfoList'">
            <div class="basicTitle">单位信息</div>
            <template v-if="peopleList.unitInfoList&&peopleList.unitInfoList.length===1">
              <template v-for="item in unitlright" :key="item.prop">
                <div class="basicItem">
                  <span>{{item.name}}:</span>
                  <span v-for="l in peopleList.unitInfoList"
                  :key="l.unitId">
                  {{l[item.prop]}}
                  </span>
                </div>
              </template>
            </template>
          </div>
          <ul class='search-results' v-if="modelShow==='unitInfoList'">
            <template v-if="peopleList.unitInfoList&&peopleList.unitInfoList.length>1">
            <template  v-for="l in peopleList.unitInfoList"
                  :key="l.regionId" >
              <li class='results-item'>
                <div class='item-details'>
                  <div class='details-info'>
                    <span class='label'>单位名称</span>
                    <span class='value'>{{l.unitName}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>单位类别</span>
                    <span class='value'>{{l.unitTypeDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>重点单位</span>
                    <span class='value'>{{l.keyunitDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>经济类型</span>
                    <span class='value'>{{l.economicType}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>行业类别</span>
                    <span class='value'>{{l.industryTypeDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>上级名称</span>
                    <span class='value'>{{l.higherName}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>注册资金</span>
                    <span class='value'>{{l.registerMoney}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>联系电话</span>
                    <span class='value'>{{l.unitTelphone}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>网址</span>
                    <span class='value'>{{l.url}}</span>
                  </div>
                </div>
              </li>
              </template>
            </template>
          </ul>
          <div v-if="modelShow==='carInfoList'">
            <template v-if="peopleList.carInfoList&&peopleList.carInfoList.length===1">
            <div class="basicTitle">车辆信息</div>
              <template v-for="item in carright" :key="item.prop">
                <div class="basicItem">
                  <span>{{item.name}}:</span>
                  <span v-for="l in peopleList.carInfoList"
                  :key="l.unitId">
                  {{l[item.prop]}}
                  </span>
                </div>
              </template>
            </template>
          </div>
          <ul class='search-results' v-if="modelShow==='carInfoList'">
            <template v-if="peopleList.carInfoList&&peopleList.carInfoList.length>1">
            <template  v-for="l in peopleList.carInfoList"
                  :key="l.regionId" >
              <li class='results-item'>
                <div class='item-details'>
                  <div class='details-info'>
                    <span class='label'>车牌号</span>
                    <span class='value'>{{l.carNumber}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>车辆品牌</span>
                    <span class='value'>{{l.carBrandDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>车辆类型</span>
                    <span class='value'>{{l.carType}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>车身颜色</span>
                    <span class='value'>{{l.carColorDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>使用性质</span>
                    <span class='value'>{{l.function}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>机动车所有人</span>
                    <span class='value'>{{l.prisonId}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>证件号码</span>
                    <span class='value'>{{l.cardNumber}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>联系电话</span>
                    <span class='value'>{{l.telphone}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>户籍行政区划</span>
                    <span class='value'>{{l.createTime}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>户籍详细地址</span>
                    <span class='value'>{{l.createTime}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>初次登记日期</span>
                    <span class='value'>{{l.createTime}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>发牌机关</span>
                    <span class='value'>{{l.carOffice}}</span>
                  </div>
                </div>
              </li>
              </template>
            </template>
          </ul>
          <div v-if="modelShow==='regionInfoList'">
            <template v-if="peopleList.regionInfoList&&peopleList.regionInfoList.length===1">
            <div class="basicTitle">社区信息</div>
              <template v-for="item in communityright" :key="item.prop">
                <div class="basicItem">
                  <span>{{item.name}}:</span>
                  <span v-for="l in peopleList.regionInfoList"
                  :key="l.regionId">
                  {{l[item.prop]}}
                  </span>
                </div>
              </template>
            </template>
          </div>
          <ul class='search-results' v-if="modelShow==='regionInfoList'">
            <template v-if="peopleList.regionInfoList&&peopleList.regionInfoList.length>1">
            <template  v-for="l in peopleList.regionInfoList"
                  :key="l.regionId" >
              <li class='results-item'>
                <div class='item-details'>
                  <div class='details-info'>
                    <span class='label'>社区名称</span>
                    <span class='value'>{{l.name}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>所属街道</span>
                    <span class='value'>{{l.levelName}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>经纬度</span>
                    <span class='value'>{{l.latitude}}</span>
                  </div>
                </div>
              </li>
              </template>
            </template>
          </ul>
          <div v-if="modelShow==='securityInfoList'">
            <template v-if="peopleList.securityInfoList&&peopleList.securityInfoList.length===1">
            <div class="basicTitle">安防设备</div>
              <template v-for="item in securityright" :key="item.prop">
                <div class="basicItem">
                  <span>{{item.name}}:</span>
                  <span v-for="l in peopleList.securityInfoList"
                  :key="l.securityFacilitiesId">
                  {{l[item.prop]}}
                  </span>
                </div>
              </template>
            </template>
          </div>
          <ul class='search-results' v-if="modelShow==='securityInfoList'">
            <template v-if="peopleList.securityInfoList&&peopleList.securityInfoList.length>1">
            <template  v-for="l in peopleList.securityInfoList" :key="l" >
              <li class='results-item'>
                <div class='item-details'>
                  <div class='details-info'>
                    <span class='label'>设施名称</span>
                    <span class='value'>{{l.securityName}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>设施类别</span>
                    <span class='value'>{{l.securityTypeDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>设施型号</span>
                    <span class='value'>{{l.securityModel}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>安装地址</span>
                    <span class='value'>{{l.securityAddress}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>所属小区</span>
                    <span class='value'>{{l.name}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>备注</span>
                    <span class='value'>{{l.comment}}</span>
                  </div>
                </div>
              </li>
              </template>
            </template>
          </ul>
          <div v-if="modelShow==='equipmentInfoList'">
            <template v-if="peopleList.equipmentInfoList&&peopleList.equipmentInfoList.length===1">
            <div class="basicTitle">实有装备</div>
              <template v-for="item in equipmentright" :key="item.prop">
                <div class="basicItem">
                  <span>{{item.name}}:</span>
                  <span v-for="l in peopleList.equipmentInfoList"
                  :key="l.regionId">
                  {{l[item.prop]}}
                  </span>
                </div>
              </template>
            </template>
          </div>
          <ul class='search-results' v-if="modelShow==='equipmentInfoList'">
            <template v-if="peopleList.equipmentInfoList&&peopleList.equipmentInfoList.length>1">
            <template  v-for="l in peopleList.equipmentInfoList" :key="l" >
              <li class='results-item'>
                <div class='item-details'>
                  <div class='details-info'>
                    <span class='label'>装备名称</span>
                    <span class='value'>{{l.equipmentName}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>资产编号</span>
                    <span class='value'>{{l.equipmentId}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>责任人</span>
                    <span class='value'>{{l.prisonId}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>联系电话</span>
                    <span class='value'>{{l.telphone}}</span>
                  </div>
                </div>
              </li>
              </template>
            </template>
          </ul>
          <div v-if="modelShow==='strengthInfoList'">
            <template v-if="peopleList.strengthInfoList&&peopleList.strengthInfoList.length===1">
            <div class="basicTitle">实有力量</div>
              <template v-for="item in powerright" :key="item.prop">
                <div class="basicItem">
                  <span>{{item.name}}:</span>
                  <span v-for="l in peopleList.strengthInfoList"
                  :key="l.regionId">
                  {{l.prisonInfo[item.prop]}}
                  </span>
                </div>
              </template>
            </template>
          </div>
          <ul class='search-results' v-if="modelShow==='strengthInfoList'">
            <template v-if="peopleList.strengthInfoList&&peopleList.strengthInfoList.length>1">
            <template  v-for="l in peopleList.strengthInfoList" :key="l" >
              <li class='results-item'>
                <div class='item-details'>
                  <div class='details-info'>
                    <span class='label'>姓名</span>
                    <span class='value'>{{l.prisonInfo.name}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>性别</span>
                    <span class='value'>{{l.prisonInfo.sexDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>证件号码</span>
                    <span class='value'>{{l.prisonInfo.cardNumber}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>民族</span>
                    <span class='value'>{{l.prisonInfo.nationDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>文化程度</span>
                    <span class='value'>{{l.prisonInfo.educationDict}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>居住地址</span>
                    <span class='value' :title="l.prisonInfo.houseAddress">{{l.prisonInfo.houseAddress}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>联系电话</span>
                    <span class='value'>{{l.prisonInfo.telphone}}</span>
                  </div>
                  <div class='details-info'>
                    <span class='label'>更新时间</span>
                    <span class='value'>{{l.prisonInfo.updateTime}}</span>
                  </div>
                </div>
              </li>
              </template>
            </template>
          </ul>
      </div>
      </el-card> -->
    </div>
  </div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  watch,
  nextTick,
} from "vue";
import {
  peopleright,
  communityright,
  equipmentright,
  powerright,
  securityright,
} from "./fileManagement";
import { infoQuery } from "@/api/realHouse/realHouse.js";
import commentright from "./commentright";
export default defineComponent({
  name: "",
  components: { commentright },
  props: {
    grandsonVisible: {
      type: Boolean,
    },
    showType: {
      type: String,
    },
    prisonId: {
      type: Number,
    },
  },
  setup(props, context) {
    const data = reactive({
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      childFalse: false,
      prisonIds: 0,
      peopleList: {},
      modelShow: "prisonInfoList",
      centerList: [
        { name: "居住人员", type: "1", id: "1" },
        { name: "水电气信息", type: "2", id: "2" },
        { name: "安防设施", type: "3", id: "3" },
        { name: "力量装备", type: "4", id: "4" },
        { name: "房主", type: "5", id: "5" },
        { name: "警情", type: "6", id: "6" },
        { name: "事件", type: "7", id: "7" },
      ],
      homepeople: [
        { name: "姓名", prop: "" },
        { name: "性别", prop: "" },
        { name: "民族", prop: "" },
        { name: "出生日期", prop: "" },
        { name: "联系电话", prop: "" },
        { name: "与房主关系", prop: "" },
      ],
      dataLable: [
        {
          name: "用水信息",
          id: 2,
          children: [
            {
              label: "时间",
              prop: "carNumber",
            },
            {
              label: "用水量",
              prop: "carNumber",
            },
          ],
        },
        {
          name: "用电信息",
          id: 2,
          children: [
            {
              label: "时间",
              prop: "carNumber",
            },
            {
              label: "用电量",
              prop: "carNumber",
            },
          ],
        },
        {
          name: "用气信息",
          id: 2,
          children: [
            {
              label: "时间",
              prop: "carNumber",
            },
            {
              label: "用气量",
              prop: "carNumber",
            },
          ],
        },
      ],
    });
    const refData = toRefs(data);
    watchEffect(() => {
      data.childFalse = props.grandsonVisible;
    });
    watchEffect(() => {
      context.emit("update:grandsonVisible", data.childFalse);
    });

    watchEffect(() => {
      if (props.prisonId) {
        data.prisonIds = props.prisonId;
        nextTick(() => {
          infoQuerylist();
        });
      }
    });
    const childback = () => {
      data.childFalse = false;
    };
    const infoQuerylist = async () => {
      if (props.showType === "4") {
        const res = await infoQuery(data.prisonIds);
        console.log(data.prisonIds);
        data.peopleList = res.houseInfo;
      }
    };
    // 点击中间切换
    const clickCenter = (item) => {
      data.modelShow = item.further;
      infoQuerylist();
      console.log(" clickCenter ~ item", item);
    };

    return {
      ...refData,
      childback,
      clickCenter,
      communityright,
      equipmentright,
      powerright,
      securityright,
      peopleright,
    };
  },
});
</script>
<style  lang='scss' scoped >
.rightcenter {
  flex: 1;
}
.fileHouse {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  display: flex;
  flex-direction: column;
  .topBox {
    line-height: 66px;
    border-bottom: 1px solid #f1f2f5;
    padding: 0 20px;
  }
  .bottomBox {
    display: flex;
    flex: 1;
    overflow: auto;
  }
  .tree-card {
    height: 100%;
    width: 400px;
  }
  .basic {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    .basicTitle {
      color: #000;
      line-height: 40px;
      font-weight: bold;
    }
    .basicImgbox {
      width: 100%;
      height: 180px;
      display: flex;
      .basicImg {
        width: 110px;
        height: 100%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .basicName {
        flex: 1;
      }
    }
    .basicItem {
      flex: 1;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f1f2f5;
      padding: 10px 0;
      line-height: 24px;
      span {
        // width: 206px;
      }
    }
  }
  .center-card {
    flex: 1;
    position: relative;
    .centerbg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 386px;
      height: 386px;
      img {
        width: 100%;
        height: 100%;
      }
      .imgone {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgtwo {
        width: 75%;
        height: 75%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgthree {
        width: 50%;
        height: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-image: url("~@/assets/images/threeSolid/threecor.png");
        background-size: 100%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 100%;
        }
      }
    }
    .centerbtn {
      width: 386px;
      height: 386px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .btnitem {
        width: 66px;
        height: 66px;
        text-align: center;
        line-height: 66px;
        border-radius: 100%;
        color: #fff;
        background: #388ff3;
        position: absolute;
        cursor: pointer;
        &:nth-child(1) {
          left: 50%;
          top: -30px;
        }
        &:nth-child(2) {
          left: 75%;
          top: 30px;
        }
        &:nth-child(3) {
          left: 90%;
          top: 50%;
        }
        &:nth-child(4) {
          left: 70%;
          top: 83%;
        }
        &:nth-child(5) {
          left: 35%;
          bottom: -27px;
        }
        &:nth-child(6) {
          left: 20%;
          bottom: 61px;
          width: 45px;
          height: 45px;
          line-height: 42px;
        }
        &:nth-child(7) {
          left: -3%;
          bottom: 24%;
        }
        &:nth-child(8) {
          left: -1%;
          top: 110px;
        }
        &:nth-child(9) {
          left: 10%;
          top: 0px;
        }
      }
    }
  }
  .search-results {
    width: 100%;
    flex: 1;
    overflow: auto;
    margin-top: 5px;
    .results-item {
      padding: 10px 0;
      width: 100%;
      border-bottom: 1px solid #aab2c5;
      @include flex-row-s-c;
      .item-img {
        width: 100px;
        img {
          width: 100%;
        }
      }
      .item-details {
        flex: 1;
        margin-left: 10px;
        line-height: 28px;
        .details-info {
          font-size: 14px;
          @include flex-row-sb-c;
          & > span {
            display: inline-block;
          }
          .label {
            width: 90px;
          }
          .value {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>